import * as types from './types';

const INITIAL_STATE = {
  calendarData: [],
  report: '',
  fetchError: null,
  isFetching: false,
  controlInfo: {},
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.MBEREPORT_GETCALENDARS:
      return {
        ...state,
        calendarData: action.payload.data,
      };
    case types.MBEREPORT_GETREPORT:
      return {
        ...state,
        report: action.payload.data !== '' ? action.payload.data : 'No Data',
      };
    case types.MBEREPORT_GETCONTROLINFO:
      return {
        ...state,
        controlInfo: action.payload.data,
      };
    case types.MBEREPORT_FETCHING:
      return {
        ...state,
        isFetching: action.payload,
      };
    case types.MBEREPORT_CLEARREPORT:
      return {
        ...state,
        report: '',
      };
    case types.MBEREPORT_FETCHERROR:
      return {
        ...state,
        fetchError: {
          Title: 'Error',
          Message: 'An error has occurred. Please try again',
        },
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/mbereport/state/reducer.js